module.exports = __webpack_public_path__ + "static/media/lady on bench.3ad29fa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/lady on bench.jpg
// module id = 455
// module chunks = 0